import React, { useEffect, useRef, useState } from 'react';

import { TextField } from '@mui/material';

import Styles from '../lib/Styles';
import classes from './SelectField.module.scss';

export default function SelectTitle(props: any) {
  const {selectedTitle, setSelectedTitle, onChangeTitle, readOnly } = props;
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [lengthTitle, setLengthTitle] = useState<number>(selectedTitle ? selectedTitle.length : 0);
  const [showHelper, setShowHelper] = useState<boolean>(false);
  const maxNumberOfCharacters: number = 200;

  useEffect(() => {
    if (initialValue.current) {
      setLengthTitle(initialValue.current.length);
      setSelectedTitle(initialValue.current);
      initialValue.current = undefined;
    }
  }, [setSelectedTitle])

  // Only numeric key input will trigger this handleChange method.
  // Don't allow more than 5 digits to be entered.
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let lengthValue = value.length;
    if (lengthValue > maxNumberOfCharacters) {
      value = value.substr(0, maxNumberOfCharacters);
    }
    setLengthTitle(value.length);
    setSelectedTitle(value);
    onChangeTitle();
  };

  return (
    <form className={cx('root')} noValidate autoComplete="off">
      <div>
        <TextField
          disabled={readOnly}
          label="Campaign Title"
          helperText={ !showHelper ? '' : (maxNumberOfCharacters - lengthTitle).toLocaleString() +  ' characters left'}
          multiline
          defaultValue={undefined}
          inputProps={{
            readOnly: readOnly
          }}
          variant="outlined"
          value={selectedTitle}
          onInput={handleTitleChange}
          onFocus={() => setShowHelper(true)}
          onBlur={() => setShowHelper(false)}
          placeholder="Enter title here."
          required={true}
        />
      </div>
    </form>
  );
}